import { h } from 'vue';

import Website from './Website.vue';
import Api from './Api.vue';
import Whatsapp from './CloudWhatsapp.vue';
import Facebook from './Facebook.vue';
import ForwardToOption from './emailChannels/ForwardToOption.vue';

const channelViewList = {
  web_widget: Website,
  api: Api,
  whatsapp: Whatsapp,
  facebook_page: Facebook,
  email: ForwardToOption,
};

export default {
  create() {
    return {
      props: {
        channel_name: {
          type: String,
          required: true,
        },
      },
      name: 'new-channel-form-view',
      render() {
        return h(channelViewList[this.channel_name] || null);
      },
    };
  },
};
